import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as StoreModel from '../../../model/ngrx';
import { CURRENT_ENVIROMENT, SERVICE_END_POINT } from 'src/app/shared/index';
import { ComponentTypes, Attributes } from 'src/app/model/ui-rule-response-model';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { QuoteDataCaptureService } from 'src/app/shared/services/api-services/quote-datacapture.service';
import { ATTRIBUTE_NAME_ID } from 'src/app/pages/user-details/config/ceding-fund-attribute-id';
import { UiRuleReqPayload, AttributeReqPayLoad, ComponentAttributes } from 'src/app/model/ui-rule-request-payload';
import { ATTRIBUTE_NAMES_CONST } from 'src/app/shared/services/api-constants/attribute-names-constant';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/state/app.state';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const HOME: string = 'home';
const DCJ: string = 'DCJ';
const CUSTOMER_CHANNEL: string = 'D';

@Injectable({ providedIn: 'root' })
export class uiCompJsonResolver implements Resolve<any> {
  productChoice: StoreModel.ProductChoice;
  productChoiceStore: Observable<StoreModel.ProductChoice[]>;
  public panelName: string = '';
  public isConfigurable: boolean = false;

  constructor(private httpClient: HttpClient, private router: Router, private quoteDatacaptureService: QuoteDataCaptureService){}
  private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<ComponentTypes> | Promise<ComponentTypes> | any {
    let screenToFetch: string;
    let uiRulesJsonUrl: string;
    let reqPayLoad: ComponentAttributes;

    switch (state.url) {
      case "/home/your-pension-savings": {
        uiRulesJsonUrl = this.endPoints['cedingFundUiRulesJsonUrl'];
        reqPayLoad = this.quoteDatacaptureService.prepareReqPayloadCustomerScreen();
        this.isConfigurable = true;
        break;
      }
      default: {
        this.isConfigurable = false;
        break;
      }
    }
    if (this.isConfigurable) {
      return this.quoteDatacaptureService.fetchUIResponseJson(uiRulesJsonUrl, reqPayLoad);
    } else {
      return null;
    }

  }
}
